export namespace FormFieldUtils {
  export const imageRecordFormats = ['.jpeg', '.jpg', '.png', '.webp'];

  export type AllowedRecordFormats = 'any' | 'image';

  export function getInputAcceptFileAttribute(allowedRecordFormats: FormFieldUtils.AllowedRecordFormats[]): string {
    if (allowedRecordFormats == null || allowedRecordFormats.includes('any') || allowedRecordFormats.length === 0) {
      return '';
    }

    const accepts: string[] = [];

    if (allowedRecordFormats.includes('image')) {
      accepts.push(...imageRecordFormats);
    }

    return accepts.join(',');
  }
}
